// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PresentationSystemPromptsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PresentationSystemPromptsQuery = { __typename?: 'Query', presentationSystemPrompts: Array<{ __typename?: 'PresentationSystemPrompt', key: string, prompt: string }> };

export const Operations = {
  Query: {
    PresentationSystemPrompts: 'PresentationSystemPrompts' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const PresentationSystemPromptsDocument = gql`
    query PresentationSystemPrompts {
  presentationSystemPrompts {
    key
    prompt
  }
}
    `;

/**
 * __usePresentationSystemPromptsQuery__
 *
 * To run a query within a React component, call `usePresentationSystemPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresentationSystemPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresentationSystemPromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePresentationSystemPromptsQuery(baseOptions?: Apollo.QueryHookOptions<PresentationSystemPromptsQuery, PresentationSystemPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PresentationSystemPromptsQuery, PresentationSystemPromptsQueryVariables>(PresentationSystemPromptsDocument, withFetchPolicyContext(options));
      }
export function usePresentationSystemPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresentationSystemPromptsQuery, PresentationSystemPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PresentationSystemPromptsQuery, PresentationSystemPromptsQueryVariables>(PresentationSystemPromptsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function usePresentationSystemPromptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PresentationSystemPromptsQuery, PresentationSystemPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PresentationSystemPromptsQuery, PresentationSystemPromptsQueryVariables>(PresentationSystemPromptsDocument, withFetchPolicyContext(options));
        }
export type PresentationSystemPromptsQueryHookResult = ReturnType<typeof usePresentationSystemPromptsQuery>;
export type PresentationSystemPromptsLazyQueryHookResult = ReturnType<typeof usePresentationSystemPromptsLazyQuery>;
export type PresentationSystemPromptsSuspenseQueryHookResult = ReturnType<typeof usePresentationSystemPromptsSuspenseQuery>;
export type PresentationSystemPromptsQueryResult = Apollo.QueryResult<PresentationSystemPromptsQuery, PresentationSystemPromptsQueryVariables>;